//#region import
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import { Convert, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { FormProvider, useForm } from 'react-hook-form';
import { ApiProject } from 'enum/api';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { GetMenuPermission } from 'utilities/SystemFunction';
import AccordionPanel from 'view/FrontEnd/Project/components/AccordionPanel';
import ProjectSectionArrangeOrder from './ProjectSectionArrangeOrder';
import { BtnSend } from 'components/Button/ButtonAll';
import { List as LINQ } from "linqts";
import { useLocation } from 'react-router';
import ContentWrapper from 'view/FrontEnd/Project/components/ContentWrapper';
//#endregion

const ProjectArrangeOrder = () => { //จัดลำดับโครงการ
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    //#region useState
    const [isPermission, setPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    const [arrYearID, setarrYearID] = useState([]);
    const [lstSectionTypeID, setlstSectionTypeID] = useState([]); //ข้อมูลมาตราทั้งหมด
    const [lstProjectSectionType, setlstProjectSectionType] = useState([]); //ข้อมูลโครงการทั้งหมด ตามมาตรา

    const [sYear, setsYear] = useState(null);
    const [nStatusID, setnStatusID] = useState(null);
    const [nProjectOrderID, setnProjectOrderID] = useState();
    const [isBtnArrangeOrder, setisBtnArrangeOrder] = useState(false);    
    //#endregion

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nYearID: null,
        } as any,
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        GetFormInitial();
    }, []);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectArrangeOrder, {}, (result) => { 
            setarrYearID(result.lstYearID);
            if((result.lstYearID || []).length > 0) form.setValue("nYearID", result.lstYearID[0].value);
        });
    }

    useEffect(() => {
        let nYearID = Convert.StringToIntOrNull(form.getValues("nYearID"));
        if (nYearID !== null) {
            GetFormProjectArrangeOrder(nYearID);
            let sYear_TH = nYearID + 543;
            setsYear(sYear_TH);
        }
    }, [form.watch("nYearID")]);

    const GetFormProjectArrangeOrder = (nYearID) => {
        AxiosFn.Get(ApiProject.GetFormProjectArrangeOrder, { nYearID : nYearID }, (result) => { 
            setnStatusID(result.nStatusID);
            setnProjectOrderID(result.nProjectOrderID);
            setlstSectionTypeID(result.lstSectionTypeID);
            setlstProjectSectionType(result.lstProjectSectionType);
            // let nSumArrangeOrder = new LINQ<any>(result.lstProjectSectionType || []).Where(w => w.lstArrangeOrder.length > 0).Select(o => o.lstArrangeOrder).ToArray();
            // setisBtnArrangeOrder(nSumArrangeOrder.length > 0);
            setisBtnArrangeOrder(result.isBtnArrangeOrder);
        });
    }

    const handleSubmit = (nStatusID: EnumProjectStatusID) => {
        let param = {
            sLocation: location.pathname,  
            nStatusID: nStatusID,
            nProjectOrderID: nProjectOrderID,
            nYearID: form.getValues("nYearID"),
            lstSectionTypeID: lstSectionTypeID,
            lstProjectSectionType: lstProjectSectionType,
        };
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectArrangeOrder, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        let nYearID = form.getValues("nYearID");
                        if (nYearID !== null) GetFormProjectArrangeOrder(nYearID);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '2%', paddingBottom: '1%', paddingTop: '2%', paddingRight: '1%', }}> 
            <FormProvider {...form}>
                <Grid item xs={12} md={2} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <SelectItem
                        id="nYearID"
                        name="nYearID"
                        options={arrYearID}
                        label={"โครงการประจำปี"}
                        required={true}
                        disabled={!isPermission}
                        IsClearable={true}
                    />
                </Grid> 
                <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1%', borderRadius: '10px', paddingBottom: '1%', padding: '2%'}}>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                            <Typography variant='h6' color={'#225192'}>{"ตารางสรุปการให้คะแนนโครงการที่ขอรับการสนับสนุนจากกองทุนจัดการซากดึกดำบรรพ์ ประจำปีบัญชี พ.ศ. " + (sYear ?? "")}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                            <Typography variant='h6' color={'#225192'}>จากอนุกรรมการกลั่นกรองข้อเสนอโครงการฯ</Typography>
                        </Grid>
                    </Grid>                
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        {(lstSectionTypeID || []).map((iSectionType) => {       
                            let clone = [...lstProjectSectionType].filter(f => f.nSectionID === iSectionType.value);
                            let _lstProjectSectionType = [].concat(...clone.map(m => m.lstArrangeOrder));   

                            return (
                                <AccordionPanel
                                    header={iSectionType.label}
                                    isExpanded={false} 
                                    color="white"
                                    bgColor="rgb(102,151,245)"
                                    background="#e79a09"
                                    expandIconColor="white"
                                    borderColor="1px solid #e79a09"
                                    borderRadius="20px !important"
                                    boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                    boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                                >
                                    <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                        <ProjectSectionArrangeOrder
                                            nSectionID={iSectionType.value}
                                            isPermission={nStatusID === 10 ? false : isPermission}
                                            lstProjectSectionType={_lstProjectSectionType ?? []} 
                                            setlstProjectSectionType={(e) => {
                                                let lstSectionType = [...lstProjectSectionType].filter(f => f.nSectionID !== iSectionType.value); 
                                                let lstSectionTypeNew = [...lstProjectSectionType].filter(f => f.nSectionID === iSectionType.value); 
                                                (lstSectionTypeNew || []).forEach((f) => {
                                                    f.lstArrangeOrder = e;
                                                }); 
                                                setlstProjectSectionType([...lstSectionType, ...lstSectionTypeNew]);
                                            }}
                                        />
                                    </Grid>                            
                                </AccordionPanel>
                            );
                        })}
                    </Grid>                    
                </ContentWrapper>                
                {isBtnArrangeOrder &&
                    <Grid item xs={12} md={12} container spacing={2} justifyContent="center" style={{ marginTop: '2%', paddingBottom: '1%', }} >
                        {/* TmProjectStatus (9,10) => 9 แสดงปุ่ม บันทึกมติจัดลำดับคะแนน, 10 ไม่แสดงปุ่มใดเลย */}
                        {nStatusID === null ?
                                <BtnSend id={"btnSendArrangeOrder"} IsDisabled={!isPermission} txt={I18n.SetText("Button.SendArrangeOrder", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumProjectStatusID.nStatusID_9) }} />
                            : nStatusID === 9 ?
                                <BtnSend id={"btnSendResolutioArrangeOrdern"} IsDisabled={!isPermission} txt={I18n.SetText("Button.SendResolutioArrangeOrdern", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumProjectStatusID.nStatusID_10) }} />
                                :
                                <></>
                        }
                    </Grid>
                }
            </FormProvider>
        </Grid> 
    )
}
export default ProjectArrangeOrder;